import { api } from '../index';

const prefix = '/api/item/userDefined/';

export function apiSelectUserDefinedGroups(param) {
	return api.get(prefix + 'groups' + param);
}

export function apiSelectUserDefinedGroup(ud_no) {
	return api.get(prefix + 'groups/' + ud_no);
}

export function apiInertUserDefinedGroup(param) {
	return api.post(prefix + 'groups', param);
}

export function apiUpdateUserDefinedGroup(ud_no, param) {
	return api.put(prefix + 'groups/' + ud_no, param);
}

export function apiDeleteUserDefinedGroup(ud_no) {
	return api.delete(prefix + 'groups/' + ud_no);
}

export function apiSelectUserDefinedGroupClasses(ud_no) {
	return api.get(prefix + 'groups/class/' + ud_no);
}

export function apiSelectClassesByUserDefinedGroups(udNos) {
	return api.post(prefix + 'groups/classes', udNos);
}

export function apiInsertUserDefinedGroupClasses(ud_no, param) {
	return api.post(prefix + 'groups/class/' + ud_no, param);
}

export function apiSelectUserDefinedGroupByName(param) {
	return api.get(prefix + 'groups/name' + param);
}
